// TODO: This doesn't lives here
export const MAX_CONTENT_WIDTH = 800;
export const MAX_FORM_WIDTH = 500;
